// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { LegalConsents } from './LegalConsents';
export { LegalConsentValidator } from './LegalConsentValidator';
export * from './ConsentsList';
export * from './LegalConsents.types';
